function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M14.772 36.066c-.2-.452-.548-.498-.689-.498-.14 0-.489.045-.678.473l-.52 1.172c-.43.976-1.694.868-1.995-.16l-1.14-3.855-.718 2.435c-.4 1.35-1.516 2.256-2.776 2.256h-.84c-.598 0-1.083-.547-1.083-1.222 0-.676.485-1.223 1.084-1.223h.839c.327 0 .616-.235.72-.585l1.232-4.174c.223-.749.842-1.253 1.542-1.253.7 0 1.319.503 1.542 1.253l.94 3.181c1.337-1.236 3.66-.74 4.468 1.082a.772.772 0 00.634.478v-6.273l8.667-9.708v-3.556h-9.21c-.893 0-1.624-.825-1.624-1.833V3.666H1.625C.725 3.667 0 4.485 0 5.5v35.444c0 1.016.724 1.834 1.625 1.834h22.75c.9 0 1.625-.818 1.625-1.834V37.89l-8.667-.009c-1.091-.023-2.07-.708-2.561-1.814zM26 12.978c0-.48-.17-.947-.474-1.29L18.897 4.2a1.535 1.535 0 00-1.15-.534h-.414v9.777H26v-.466zm-6.5 17.193v5.273h4.671L35.118 23.01l-4.596-5.185L19.5 30.17zm18.995-13.722l-2.158-2.435c-.673-.759-1.765-.759-2.438 0l-1.845 2.082 4.596 5.185 1.845-2.081c.674-.76.674-1.992 0-2.751z"
}));

var SvgFill = function SvgFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 39 44",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fill.5e38ef6a.svg";
export { ForwardRef as ReactComponent };